export default __webpack_public_path__ + "static/media/contact-card-mobi.82229881.webp";